import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return <main className="grid min-h-[65vh] place-items-center bg-mist px-5 text-center"><div><p className="eyebrow">404 · Page not found</p><h1 className="mt-4 text-4xl font-semibold tracking-[-0.04em] text-navy">This page is not on the programme.</h1><p className="mt-4 text-slate-600">Return to the championship homepage to continue.</p><Link className="button button-primary mt-8" to="/">Return home</Link></div></main>;
}
